const e=e=>!Object.entries(e||{}).length&&!(null==e?void 0:e.length)&&!(null==e?void 0:e.size);export{e as default};
